
import FileField from "../File";


const VideoField = ({...other}) =>  (
    <FileField {...other} type="video" />
);

export default VideoField